// SVG geometry retained under the MIT license in LICENSE.txt.
import React from 'react';
import { SvgIcon } from '../primitives';
const KeyboardBackspace = React.forwardRef(function KeyboardBackspace(props, ref) {
    return <SvgIcon {...props} ref={ref}><path d="M21 11H6.83l3.58-3.59L9 6l-6 6 6 6 1.41-1.41L6.83 13H21z"/></SvgIcon>;
});
export default KeyboardBackspace;
